import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/callscreening/organisations")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: "Organisations",
      crumbTo: "/callscreening/organisations",
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
